<template >
  <div>
    <section v-if="loading">
      <div class="loader"></div>
    </section>
    <section v-else>
      <div  class="row group-section mb-1">
        <template>
          <div class="col-md-12" >
            <table :id="`${datatableId}-diskResolved`" class="table table-striped single-outage-table table-responsive">
              <thead>
              <tr class="text-center">
                <th></th>
                <th>Status</th>
                <th>Tags</th>
                <th>Test Name</th>
                <th>Server IP</th>
                <th>Causes</th>
                <!--								<th>Status Code</th>-->
                <!--								<th>Uptime</th>-->
                <th>Resolved By</th>
              </tr>
              </thead>
              <tbody >
              <tr  v-for="group in paginatedGroups" :key="group.planName">
                <td width="1%">
                  <div class="dropdown m-auto">
                    <button title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" style="width: 15px!important; padding: 0!important;" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-cog"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <a class="dropdown-item" href="javascript:void(0)" @click="openModal(group, 'viewDiskAlertModal')">View Details</a>
                    </div>
                  </div>
                </td>
                <td></td>
                <td class="text-center" width="5%">
                    <span class="cursor-pointer">
                      <img title="Storage-Alert" class="" style="width: 20px !important;" src="../../../assets/img/disk_alert.png" alt="">
                    </span>
                </td>
                <td class="text-center" >{{group.planName}}</td>
                <td class="text-center"> <span class="ml-1" >
                      <b>{{group.serverIP}}</b>
                    </span></td>
                <td width="5%" class="text-center"> {{group.tests[group.tests.length-1].diskUsage}}</td>
                <td width="2%">
                  <div  class="d-flex align-items-center">
                    <div>
                           <span class="badge badge-pill badge-success mb-0">
                             {{group.tests[group.tests.length-1].resolvedBy}}
                           </span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
        <div class="customer-list-info col-md-12" v-if="paginatedGroups.length === 0">
          <div class="card-text text-center text-danger mb-3 font-weight-bold">
            No Suspended Outages Exists!
          </div>
        </div>
      </div>

    </section>

  </div>
</template>
<script>
import dateMixin from "@/mixins/dateMixin";
import loginAsMixin from "@/mixins/loginAsMixin";
import statisticsMixin from "@/mixins/statisticsMixin";
import AdminLogs from "@/mixins/adminLogs";
import Paginate from "vuejs-paginate";
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import moment from "moment/moment";
import md5 from "crypto-js/md5";
import _ from "lodash";

export default {
  name: "resolvedDiskStorage",
  props: ["datatableId", "status" , 'searchQuery', 'presetMacros'],
  mixins: [dateMixin, loginAsMixin, statisticsMixin, AdminLogs],
  components: {Paginate,
    affectedNodesAndRacks: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/affectedNodesAndRacks"),
  },

  data() {
    return {
      selectedFilters: [{ tag: 'all', text: 'All Tags'},
        { tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png') },
        { tag: 'disk-alert', category: 'service', src: require('@/assets/img/disk_alert.png') },
        { tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png') },
        { tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png') },
        { tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png') },
        { tag: 'squarespace',category: 'host', src: require('@/assets/img/squarespace.png') },
        { tag: 'nerdpress',category: 'cfe', src: require('@/assets/img/nerdpress.png') },
        { tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png') },
        { tag: 'wix', category: 'host', src: require('@/assets/img/wix.png') },
        { tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg') },
        { tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png') },
        { tag: 'none', text: 'No Tags'}
      ],
      allFilterSelected: false,
      notInWPOFilter: true,
      filteredOptions: [
        { tag: 'all', text: 'All Tags'},
        { tag: 'disk-alert', category: 'service', src: require('@/assets/img/disk_alert.png') },
        { tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png') },
        { tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png') },
        { tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png') },
        { tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png') },
        { tag: 'squarespace',category: 'host', src: require('@/assets/img/squarespace.png') },
        { tag: 'nerdpress',category: 'cfe', src: require('@/assets/img/nerdpress.png') },
        { tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png') },
        { tag: 'wix', category: 'host', src: require('@/assets/img/wix.png') },
        { tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg') },
        { tag: 'shopify', category: 'host', src: require('@/assets/img/shopify-tag.png') },
        { tag: 'none', text: 'No Tags'},
      ],
      tracker: {},
      affectedNodes: [],
      affectedRacks: [],
      openedGroups: [],
      loading: false,
      tests: [],
      testGroups:[],
      domainDateTime: {},
      totalDownTests: 0,
      totalPausedTests: 0,
      totalPendingTests: 0,
      totalSuspendedTests: 0,
      allNodes: {},
      planSortType: null,
      ipSortType: null,
      outageSortType: null,
      nodeSortType: null,
      rackSortType: null,
      pageNumber: 0,
      updateItem: null,
      action: null,
      pageSize: 10,
      removeItem: null,
      statusSortType: 'asc',
      downtimeType: null,
      statusList: [],
      selectedMonitorLoading: null,
      selectedPlanLoading: null,
      causeLength: 33,
      activeJobsDomainList: [],
      activeMigrationList: [],
      completedJobsDomainList: [],
      pendingJobListener : null,
      completeJobListener : null,
      migrationListener : null,
    }
  },
  mounted(){
  },
  computed:{
    user() {
      return this.$store.getters.user;
    },
    pageCount(){
      let filteredGroups = this.paginatedGroups.filter(el => el.planName!=='(N/A)' && el.planName!=='Suspended')
      let l = filteredGroups.length, s = this.pageSize;
      return Math.ceil(l/s);
    },
    paginatedGroups(){
      let filteredGroups = this.testGroups;
      if(this.searchQuery) {
        filteredGroups = filteredGroups.filter(g => {
          if(g.planName.toLowerCase().includes(this.searchQuery)){
            return true;
          }
          let isTestInclude = false;
          g.tests.map(t => {
            if(t.url.toLowerCase().includes(this.searchQuery)){
              isTestInclude = true;
            }
          });
          return isTestInclude;
        })
      } else if(this.selectedFilters.length || this.notInWPOFilter || (this.selectedFilters.length && this.notInWPOFilter)) {
        filteredGroups = filteredGroups.filter(g => {
          let isTestInclude = false
          if (this.notInWPOFilter && g.notInWPO) {
            isTestInclude = true;
          } else {
            g.tests.map(el => {
              // find if all is selected
              const isAllSelected = this.selectedFilters.find(el => el.tag === 'all');
              // find if none is selected
              const isNoneSelected = this.selectedFilters.find(el => el.tag === 'none' && !g.notInWPO);
              if (isAllSelected) {
                // find if tag categories exist
                isTestInclude = el.tagCategories && el.tagCategories.length
              } if(isNoneSelected) {
                isTestInclude = !el.tagCategories || el.tagCategories && !el.tagCategories.length
              } if(this.selectedFilters && this.selectedFilters.length) {
                const result = (el.tagCategories && el.tagCategories.length ? el.tagCategories.every(t => {
                  return this.selectedFilters.find(tag => t.tag.toLowerCase() === tag.tag && t.category.toLowerCase() === tag.category)
                }) : false) || false
                if(result) {
                  isTestInclude = true
                }
              }
            })
          }
          return isTestInclude;
        })
      }
      console.log('groups', filteredGroups)
      return filteredGroups
    },
  },
  watch: {
    paginatedGroups() {
      this.pageNumber = 0;
      this.pageSize= 10
    }
  },
  created(){
    // if(this.status !== 'Up'){
    //   setInterval(() => this.startClockTicking(), 1000);
    // }
  },
  methods: {
    nextPage(){
      this.pageNumber++;
    },
    prevPage(){
      this.pageNumber--;
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    async renderDatatable(group, type){
      group.showTests = !group.showTests
      if (type === 'openedGroups') {
        if (group.showTests) {
          this.openedGroups.push(group.planName)
        } else {
          this.openedGroups.splice(this.openedGroups.indexOf(group.planName), 1)
        }
      }

      if(type=='ungrouped')
      setTimeout(() => {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }, 300)
    },
    openModal(test, el){
       if(el === 'viewDiskAlertModal'){
        this.$parent.selectedItemForView = _.cloneDeep(test);
      }
      else{
        this.$parent.selectedItemForView = test;
      }
      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    groupTestsInAPlan(tests){
      console.log("tests", tests)
      this.tests = _.cloneDeep(tests);
      this.startGrouping()
    },
    startGrouping () {
      console.log(this.tests, 'after tests')
      // const openedGroups = localStorage.getItem('openedGroups') ? JSON.parse(localStorage.getItem('openedGroups')) : []
      this.testGroups=[]
      const testIps = ['69.162.173.212', '23.29.145.209']
      this.tests = this.tests.filter(test => {
        return !testIps.includes(test.serverIP)
      })
      this.tests.map(test => {
        if(test.type === 'disk-alert'){
          console.log('Storage group' , test)
          let group = {
            type : 'disk-alert',
            notInWPO: false,
            planName: test.hostBillLink,
            serverIP: test.ip || '',
            uid: test.id,
            firstName: 'Test.FirstName' ,
            tests: [...test.alerts],
            notes: (test && test.notes) ? test.notes : [],
            lastName: 'Hello',
            nodeName: '',
            rackName: '' ,
            downCount:  10 ,
            downCounts: 1,
          };
          this.testGroups.push(group);
        }
      });
        this.testGroups = _.orderBy(this.testGroups, ['downCount'], ['desc']);
      this.loading = false
      console.log('groups before', this.testGroups)
      this.renderDatatable({}, 'ungrouped')
    }
  },
  beforeDestroy() {
  }
}
</script>

<style scoped>
.dropdown-toggle:after {
  display: none;
}
.settinds-btn, .settinds-btn:active, .settinds-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.settinds-btn:hover {
  background-color: black!important;
  color: white !important;
}
</style>